/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export const SET_SEASON_PICKER_HIGHLIGHT = 'SET_SEASON_PICKER_HIGHLIGHT';

export const UPDATE_SEASON_PICKER_IN_FOCUS = 'UPDATE_SEASON_PICKER_IN_FOCUS';

export const RESET_SEASON_PICKER_STATE = 'RESET_SEASON_PICKER_STATE';

export const SET_LAST_FOCUSED_TYPE = 'SET_LAST_FOCUSED_TYPE';

export const SET_LAST_FOCUSED_PICKER_STATE = 'SET_LAST_FOCUSED_PICKER_STATE';

export const CLEAR_LAST_FOCUSED_PICKER_STATE = 'CLEAR_LAST_FOCUSED_PICKER_STATE';
